module.exports = __webpack_public_path__ + "static/media/logo-onoake-ori.34d71a1e.png";